import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  demoPlaceBetPlinkoGameService,
  getMyBetsPlinkoService, placeBetPlinkoGameService,
  plinkoGameCheckFairness,
  postLightningBoardDetailsService
} from 'network/services/plinkoGame.service'
import {
  fastModeBox, pixiCancelBall, pixiCreateBall, pixiStartMovingBall
} from 'games/fast-games/PlinkoGame/pixi-js-scripts/bridge'
import { appendCreditDemoWalletWaitQueue, debitBalance, updateCreditDemoWalletWaitQueue, updateCreditWalletWaitQueue } from 'redux-store/redux/slices/auth.slice'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { appendMyBetsPlinko, setBetLock } from 'redux-store/redux/slices/plinkoGame.slice'
import { generateClientSeed } from 'utils/common-functions/index'

export const placedBetPlinkoGame = createAsyncThunk('plinko-game/place-bet',
  async ({ payload, fastMode }, thunkApi) => {
    try {
      const res = await placeBetPlinkoGameService(payload)
      // Deducting the balance from the main balance after the bet is placed successfully
      thunkApi.dispatch(debitBalance(payload?.totalBetAmount))
      if (res?.nextServerSeedHash) {
        const newClientSeed = generateClientSeed()
        thunkApi.dispatch(setNewClientSeed(newClientSeed))
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }
      if (fastMode) {
        const dropDetails = res.bet.dropDetails
        for (let i = 0; i < dropDetails.length; i++) {
          setTimeout(() => {
            fastModeBox(dropDetails[i])
          }, 75 * i)
        }

        thunkApi.dispatch(setBetLock())
        thunkApi.dispatch(updateCreditWalletWaitQueue())
        thunkApi.dispatch(appendMyBetsPlinko())
      } else {
        const dropDetails = res.bet.dropDetails
        for (let i = 0; i < dropDetails.length; i++) {
          const lastBall = (i + 1) === dropDetails.length
          setTimeout(() => {
            pixiStartMovingBall(dropDetails[i])

            pixiCreateBall(lastBall, res.bet.winningAmount)
          }, 75 * i)
        }
        // dropDetails.forEach(detail => {
        //   pixiStartMovingBall(detail)
        //   pixiCreateBall()
        // })
      }
      return res
    } catch (error) {
      if (!fastMode) {
        pixiCancelBall()
      }
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const demoPlacedBetPlinkoGame = createAsyncThunk('plinko-game/demo-place-bet',
  async ({ payload, fastMode }, thunkApi) => {
    try {
      const res = await demoPlaceBetPlinkoGameService(payload)
      const newDemoWallet = {
        currency: payload?.currencyCode,
        balance: res?.demoBalance
      }
      thunkApi.dispatch(appendCreditDemoWalletWaitQueue(newDemoWallet))
      if (fastMode) {
        const dropDetails = res.dropDetails
        for (let i = 0; i < dropDetails.length; i++) {
          setTimeout(() => {
            fastModeBox(dropDetails[i])
          }, 75 * i)
        }
        thunkApi.dispatch(setBetLock())
        thunkApi.dispatch(updateCreditDemoWalletWaitQueue())
        thunkApi.dispatch(appendMyBetsPlinko())
      } else {
        const dropDetails = res.dropDetails
        for (let i = 0; i < dropDetails.length; i++) {
          const lastBall = (i + 1) === dropDetails.length
          setTimeout(() => {
            pixiStartMovingBall(dropDetails[i])
            pixiCreateBall(lastBall, res.winningAmount)
          }, 75 * i)
        }
      }

      return res
    } catch (error) {
      if (!fastMode) {
        pixiCancelBall()
      }
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBetsPlinko = createAsyncThunk('plinko-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsPlinkoService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const postLightningBoardDetails = createAsyncThunk('plinko-game/post-lightning-board-details', async (params, thunkApi) => {
  try {
    const res = await postLightningBoardDetailsService()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description)
  }
})

// checkFairnessPlinkoGame

export const checkFairnessPlinkoGame = createAsyncThunk('plinko-game/check-fairness', async (payload, thunkApi) => {
  try {
    const res = await plinkoGameCheckFairness(payload)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description)
  }
})
